import React, { useEffect, useRef, useState } from 'react'
import { openDB } from 'idb';

import PersonCardIcon from '../svg/PersonCardIcon.js';
import PaintIcon from '../svg/PaintIcon.js';
import LaptopCreateIcon from '../svg/LaptopCreateIcon.js';
import LongInfoIcon from '../svg/LongInfoIcon.js';
import GeneralLogoIcon from '../svg/GeneralLogoIcon.js';
import UbicationIcon from '../svg/UbicationIcon.js';

import { ApiService, countriesCurrency, returnFullURL } from './index.js';
import Select, { components } from 'react-select';
import { useNavigate, useParams } from 'react-router-dom';

import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import InfoIcon from '@mui/icons-material/Info';

import { MapContainer, TileLayer, Marker, useMapEvents, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import marcador from "../images/uvic.png";
import { toast } from "react-toastify";

const type_branchs = [
    {
        label: 'Tienda',
        value: 'tienda'
    },
    {
        label: 'Almacen',
        value: 'almacen'
    },
    {
        label: 'Central',
        value: 'central'
    }
];

const type_currency = countriesCurrency().map((item) => ({
    label: item.currency,
    value: item.code
}));

// const type_currency = [
//     {
//         label: 'Bolivianos',
//         value: 'bob'
//     }, {
//         label: 'Dolar Americano',
//         value: 'usd'
//     },
//     {
//         label: 'Euro',
//         value: 'eur'
//     },
//     {
//         label: 'Dólar australiano',
//         value: 'aud'
//     }, {
//         label: 'Sol',
//         value: 'sol'
//     }, {
//         label: 'Pesos Argentinos',
//         value: 'ars'
//     }, {
//         label: 'Rublo',
//         value: 'rub'
//     }
// ];

const paises_list = [
    {
        "key_contry": "9b62bb48407280ee047e94864316dd58808cfd5f21699",
        "name": "Argentina",
        "region": [
            {
                "key_region": "479f1537b085419cc2f78742c3afcf72726119dd06125",
                "name": "Buenos Aires"
            },
            {
                "key_region": "258bdd5d8850345ae64a11ab472c10388b786f4205c96",
                "name": "Córdoba"
            },
            {
                "key_region": "0827225b6694c7d0e4b33d91d2b285234f784573b5910",
                "name": "Mendoza"
            },
            {
                "key_region": "3ff31afdd5cc16a08542267858a79aaa31425d0b15835",
                "name": "Santa Fe"
            },
            {
                "key_region": "5f03b88521277834454526869304408af71ec840e5972",
                "name": "Tucumán"
            }
        ]
    },
    {
        "key_contry": "57289c99305283832934860299054876d45dbaa719690",
        "name": "Bolivia",
        "region": [
            {
                "key_region": "437c0942852151478208715613904fb7b1ca9b1250db0",
                "name": "Beni"
            },
            {
                "key_region": "970c54d28522739b8660454481378134871a26fe47546",
                "name": "Chuquisaca"
            },
            {
                "key_region": "28129b94cccf8854215e378073f710d4135a6d3262665",
                "name": "Cochabamba"
            },
            {
                "key_region": "9d4856232ffda0c3c352bf3779b1ad127457e53382385",
                "name": "La Paz"
            },
            {
                "key_region": "0427f22b88847890df878135d4d0858337782c4ea8e20",
                "name": "Oruro"
            },
            {
                "key_region": "53c2e68582432a9de64aa20d77793c816acfabd175741",
                "name": "Pando"
            },
            {
                "key_region": "1b2bc0f20e33ea485631fedec13d41f7769ba27514063",
                "name": "Potosí"
            },
            {
                "key_region": "6394519f78852368e910a0ec2974f2bd50297756f9a07",
                "name": "Santa Cruz"
            },
            {
                "key_region": "94ea9a0f1c894b3f92852241774b9e529640aab417892",
                "name": "Tarija"
            }
        ]
    },
    {
        "key_contry": "3848efeff7486418bd865e20361b1e761908892f10836",
        "name": "Brasil",
        "region": []
    },
    {
        "key_contry": "7e42dba912c9eb486024578c854071433127bde214841",
        "name": "Chile",
        "region": []
    },
    {
        "key_contry": "64101c87ed4860270e1058c9ddd84cb38d80b22da6b0f",
        "name": "Colombia",
        "region": []
    },
    {
        "key_contry": "0016f4e8515a255f0860295349d2683f5b4b48002705c",
        "name": "Ecuador",
        "region": []
    },
    {
        "key_contry": "5bdbea686220c68fa885789f609c58425d747a5556342",
        "name": "Guyana",
        "region": []
    },
    {
        "key_contry": "281038623768602651e39ff30a82aeaf90e74b7c52f7f",
        "name": "Paraguay",
        "region": []
    },
    {
        "key_contry": "4597279a40868286aea65199ebc681398771c4359d7d9",
        "name": "Perú",
        "region": []
    },
    {
        "key_contry": "8613e95b27ef3886234582059ea6d8542180df18b021a",
        "name": "Surinam",
        "region": []
    },
    {
        "key_contry": "980864137bea07882e5ece29d6e8c5a8d808367002386",
        "name": "Venezuela",
        "region": []
    }
];

const MyCompanyUpdate = ({ key_branch = null, closeModal, dataCompanyProvider = {}, setDataCompanyProvider = () => { }, reloadData }) => {
    const navigate = useNavigate();
    const current_view = window.location.pathname;
    const { nit } = useParams();
    const [objectCompany, setObjectCompany] = useState();
    const [listBranchs, setListBranchs] = useState([{}]);

    const [dragState, setDragState] = useState(false);
    const [stateModalMaps, setStateModalMaps] = useState(false);
    const [currentBranch, setCurrentBranch] = useState(0);
    const [stateUpload, setStateUpload] = useState(false);

    const its_company = `/administrar/empresa/cuenta/${nit}` == current_view;

    async function saveCompany(event) {
        event.preventDefault();

        const {
            companyID,
            companyName,
            companyDescription,
            country,
            colorCompany,
            logoCompany,
        } = objectCompany;

        if (companyID < 1000000 || companyID > 999999999999) return toast.info("Ingrese un identificador de empresa valido");
        if (companyName.length < 3 || companyName.length > 70) return toast.info(`Nombre de empresa ${companyName.length < 3 ? 'debe tener al menos 3 caracteres' : 'no puede exceder 70 caracteres'}`);
        if (companyDescription.length > 200) return toast.info("Descripcion de empresa no puede exceder 200 caracteres");
        if (country?.value == null) return toast.info("Pais de origen de la empresa es necesario");
        if (logoCompany == null) return toast.info("Logo de tu empresa es obligatorio ingresar");

        setStateUpload(true);

        var url_logo;
        if (logoCompany?.uploaded_file == null) {
            const formData = new FormData();
            formData.append("file", logoCompany);

            const uploadResponse = await ApiService.fetchData(
                "api/upload/file",
                { method: "POST", body: formData },
                false
            );

            if (uploadResponse?.url == null) return toast.info("Logo no fue posible publicar, intentalo mas tarde");

            setObjectCompany((current_value) => ({
                ...current_value,
                logoCompany: {
                    ...current_value.logoCompany,
                    uploaded_file: uploadResponse.url
                }
            }));

            url_logo = uploadResponse.url;
        } else {
            url_logo = logoCompany.uploaded_file;
        }

        const request_body = {
            "nit": companyID,
            "name_rs": companyName,
            "fullName": companyName,
            "description_company": companyDescription,
            "sector": "comercio",
            "logo": url_logo,
            "logo_pdf": null,
            "profile": null,
            "company_cover": null,
            "country_company": country.value,
            "theme": colorCompany || '#989d96',
            "array_sucursal": []
        };

        for (const branchs of listBranchs) {
            const request_maps = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${branchs?.lat ?? 0}&lon=${branchs?.lon ?? 0}&format=json`);

            if (!request_maps.ok) return toast.info("No pudimos obtener tu ciudad. Intenta de nuevo más tarde");

            const result_maps = await request_maps.json();
            const getCity = regiones.find(obj => obj.name == (result_maps?.address?.state ?? ""));
            if (!getCity || Object.keys(getCity).length == 0) return toast.info("Ciudad obtenida no está registrada. Contacta con soporte");

            request_body.array_sucursal.push({
                text_direction: branchs.fullName,
                description_sucursal: branchs.text_direction ?? "",
                lat: String(branchs.lat),
                long: String(branchs.lon),
                phone: branchs.phone ?? 0,
                region: getCity.key_region,
                type: branchs.type.value ?? "tienda",
                currency: branchs.currency.value
            });
        }

        const request_new_company = await ApiService.fetchData("api/company/insert", {
            method: "POST",
            body: JSON.stringify(request_body)
        });

        if (request_new_company?.code != 200) return toast.error(request_new_company?.message ?? "Error al comunicarse con el sistema, pide ayuda a soporte");

        toast.success(request_new_company?.message ?? "Registro de empresa exitoso!");
        setStateUpload(false);
        closeModal(false);
        reloadData();
    }

    async function updateCompany(event) {
        event.preventDefault();

        const {
            companyID,
            companyName,
            companyDescription,
            country,
            colorCompany,
            logoCompany,
        } = objectCompany;

        if (companyID < 1000000 || companyID > 999999999999) return toast.info("Ingrese un identificador de empresa valido");
        if (companyName.length < 3 || companyName.length > 70) return toast.info(`Nombre de empresa ${companyName.length < 3 ? 'debe tener al menos 3 caracteres' : 'no puede exceder 70 caracteres'}`);
        if (companyDescription.length > 200) return toast.info("Descripcion de empresa no puede exceder 200 caracteres");
        if (country?.value == null) return toast.info("Pais de origen de la empresa es necesario");
        if (logoCompany == null) return toast.info("Logo de tu empresa es obligatorio ingresar");

        try {
            setStateUpload(true);

            const request_body = {};
            if (dataCompanyProvider?.companyID != companyID) request_body.nit = companyID;
            if (dataCompanyProvider?.companyName != companyName) request_body.companyName = companyName;
            if (dataCompanyProvider?.companyDescription != companyDescription) request_body.companyDescription = companyDescription;
            if (typeof country == 'object' && country.label != dataCompanyProvider?.country) request_body.country = country?.value;
            if (dataCompanyProvider?.colorCompany != colorCompany) request_body.colorCompany = colorCompany;
            if (dataCompanyProvider?.logoCompany != logoCompany) {
                var url_logo;
                if (logoCompany?.uploaded_file == null) {
                    const formData = new FormData();
                    formData.append("file", logoCompany);

                    const uploadResponse = await ApiService.fetchData(
                        "api/upload/file",
                        { method: "POST", body: formData },
                        false
                    );

                    if (uploadResponse?.url == null) throw new Error("Logo no fue posible publicar, intentalo mas tarde_info");

                    setObjectCompany((current_value) => ({
                        ...current_value,
                        logoCompany: {
                            ...current_value.logoCompany,
                            uploaded_file: uploadResponse.url
                        }
                    }));

                    url_logo = uploadResponse.url;
                } else {
                    url_logo = logoCompany.uploaded_file;
                }

                request_body.logoCompany = url_logo;
            }


            if (listBranchs.length == 0) throw new Error("Es obligatorio tener al menos una sucursal_info");

            const old_data_branchs = dataCompanyProvider.lis_branchs;
            const list_branchs_update = [];

            for (let i = 0; i < listBranchs.length; i++) {
                const old_branch = old_data_branchs[i] ?? {};
                const new_branch = listBranchs[i];

                const temp_branch = {};
                temp_branch.key_branch = new_branch?.key_branch ?? null;
                if (new_branch?.text_direction != old_branch?.text_direction) temp_branch.description_sucursal = new_branch.text_direction ?? 'virtual';
                if (new_branch?.fullName != old_branch?.fullName) temp_branch.text_direction = new_branch.fullName;
                if (new_branch?.lat != old_branch?.lat) temp_branch.lat = String(new_branch.lat);
                if (new_branch?.lon != old_branch?.lon) temp_branch.long = String(new_branch.lon);
                if (typeof new_branch?.currency == 'object' && new_branch?.key_branch == null) temp_branch.currency = new_branch.currency.value;
                if (new_branch?.phone != old_branch?.phone) temp_branch.phone = new_branch.phone;

                if (temp_branch?.lat || temp_branch?.long) {
                    const request_maps = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${new_branch?.lat ?? 0}&lon=${new_branch?.lon ?? 0}&format=json`);

                    if (!request_maps.ok) throw new Error("No pudimos obtener tu ciudad. Intenta de nuevo más tarde_info");

                    const result_maps = await request_maps.json();
                    const getCity = regiones.find(obj => obj.name == (result_maps?.address?.state ?? ""));
                    if (getCity.name != old_branch?.region) temp_branch.region = getCity.key_region;
                }

                if (typeof new_branch?.type == 'object' && new_branch.type.value != old_branch?.type) temp_branch.type = new_branch.type.value;

                const count_keys = Object.keys(temp_branch).length;
                if ((count_keys > 1 && new_branch?.key_branch != null) || (new_branch?.key_branch == null && count_keys == 9)) list_branchs_update.push(temp_branch);
            }
            console.log(list_branchs_update);
            const update_status = Object.keys(request_body).length > 0;

            if (list_branchs_update.length > 0) request_body.array_sucursal = list_branchs_update;

            if (Object.keys(request_body).length == 0) throw new Error("No se detectaron cambios para actualizar_info");

            const request_update_company = await ApiService.fetchData(`api/company/update/account?key_branch=${key_branch}`, {
                method: "PUT",
                body: JSON.stringify(request_body)
            });

            if (request_update_company?.code != 200) throw new Error((request_update_company?.message ?? 'Actualizacion fallida, contacta a soporte') + "_error");

            if (request_update_company?.logo_url) objectCompany.logoCompany = request_update_company.logo_url;

            reloadData({ ...objectCompany, updated: update_status }, request_body.array_sucursal, (request_update_company?.new_branchs ?? []));

            if (request_body?.nit) navigate(`/administrar/empresa/cuenta/${request_body.nit}`, { replace: true });
            if (request_update_company?.code == 200) {
                toast.success("“¡Listo! Los cambios estarán disponibles pronto para todos en tu empresa.");

                const tempDataDB = await openDB('data-storage', 3, {
                    upgrade(db) {
                        if (!db.objectStoreNames.contains('companies')) db.createObjectStore('companies', { keyPath: 'id' });
                    },
                });
                await tempDataDB.clear("companies");


                setTimeout(() => {
                    window.location.reload();
                }, 4200)
            }
        } catch (error) {
            const object_error = error?.message ? String(error?.message).split("_") : null;

            if (object_error.length == 2) {
                toast[object_error[1]](object_error[0]);
            } else {
                toast.info("Error inesperado. Intenta de nuevo o contacta soporte");
            }
        } finally {
            setStateUpload(false);
        }
    }

    const styleIcons = {
        height: '35px',
        width: '42px',
        padding: '3px',
        backgroundColor: '#fff',
        borderRadius: '10px'
    };

    const customStyles = (itsCompany = true) => {
        return {
            container: (provided) => ({
                ...provided,
                width: '100%', // Asegura que el Select siempre ocupe el 100% del ancho
            }),
            control: (base, state) => ({
                ...base,
                backgroundColor: itsCompany ? 'var(--theme-main)' : '#313131', // Fondo transparente
                border: 'none',                 // Sin borde
                boxShadow: 'none',              // Sin sombra al enfocar
                borderRadius: '15px',
                '&:hover': {
                    border: 'none',
                },
                color: itsCompany ? '#000' : 'var(--theme-main)',
                fontSize: '16px',
                width: '100%',
                cursor: 'text',
            }),
            dropdownIndicator: (base) => ({
                ...base,
                color: itsCompany ? '#313131' : 'var(--theme-main)', // Cambia el color del ícono si quieres
                cursor: 'pointer',
            }),
            indicatorSeparator: () => ({
                display: 'none', // Oculta la línea entre el input y el ícono
            }),
            menu: (base) => ({
                ...base,
                backgroundColor: itsCompany ? 'var(--theme-main)' : '#313131', // Fondo del menú desplegable
                border: '1px solid #ccc',
                color: itsCompany ? '#000' : 'var(--theme-main)',
                fontSize: '16px',
            }),
            singleValue: (provided, state) => ({
                ...provided,
                color: !itsCompany ? 'var(--theme-main)' : '#313131',
                paddingLeft: '10px',
                width: '100%',
            }),
            option: (provided, state) => ({
                ...provided,
                '&:hover': {
                    backgroundColor: 'rgba(0,0,0,0.3)',
                },
                backgroundColor: state.isSelected && 'rgba(0,0,0,0.5)',
            }),
            input: (base) => ({
                ...base,
                margin: 0,
                padding: 0,
                // opacity: 0,      // <-- Oculta el input
                width: 0,        // <-- Evita que empuje el texto
                cursor: 'default',
                color: !itsCompany ? 'var(--theme-main)' : '#313131'
            })
        };
    }

    const refCompanyObj = useRef(null);

    function addImage(event) {
        event.preventDefault();
        const file_selected = event.target.files[0];
        if (!file_selected) return;
        file_selected.temporal_img = URL.createObjectURL(file_selected);

        handleValueCompany(file_selected, 'logoCompany');
        setDragState(false);
    }

    function addBranch(event) {
        event.preventDefault();
        event.stopPropagation();

        setListBranchs((current_val) => {
            const newBranch = [...current_val];

            newBranch.push({
                fullName: `Local ${current_val.length + 1}`,
                phone: '',
                lat: "-17.78356160586947",
                lon: "-63.180527126488954",
                city: null,
                text_direction: '',
                type: type_branchs[0],
                currency: type_currency[0]
            });
            return newBranch;
        });

        setCurrentBranch(listBranchs.length)
    }

    function handleBranchNames(event, index, forced = false) {
        const newVal = String(event.target.value);

        setListBranchs((current_val) => {
            const current_array = [...current_val];
            current_array[index] = {
                ...current_array[index],
                fullName: newVal.length == 0 && forced ? `Local ${index + 1}` : newVal
            };

            return current_array;
        });
    }

    function removeBranch(event, position) {
        event.preventDefault();
        event.stopPropagation();

        setListBranchs((current_val) => {
            const current_array = [...current_val];
            current_array.splice(position, 1);

            return current_array.length == 0 ? [{
                fullName: `Local ${current_val.length + 1}`,
                phone: '',
                lat: "-17.78356160586947",
                lon: "-63.180527126488954",
                city: null,
                text_direction: '',
                type: type_branchs[0],
                currency: type_currency[0]
            }] : current_array;
        });

        const newPosition = currentBranch - 1;
        setCurrentBranch(newPosition < 0 ? 0 : (newPosition < position ? (currentBranch == position ? (newPosition) : (newPosition + 1)) : newPosition));
    }

    const customIcon = new L.Icon({
        iconUrl: marcador,
        iconSize: [32, 32], // o ajusta a lo que necesites
        iconAnchor: [16, 32], // punto de anclaje en el ícono
        popupAnchor: [0, -32], // punto donde aparece el popup
    });

    function MapClickHandler({ onMapClick }) {
        useMapEvents({
            click: (e) => {
                onMapClick(e.latlng);
            },
        });
        return null; // no renderiza nada
    }

    function updateCoordenadas(lag, lan) {
        const latNum = parseFloat(lag);
        const lngNum = parseFloat(lan);
        if (isNaN(latNum) || isNaN(lngNum)) {
            toast.error("Lat/Lng inválidos");
            return;
        }
        setListBranchs((current_value) => {
            const current_list = [...current_value];

            current_list[currentBranch] = {
                ...current_list[currentBranch],
                lat: latNum,
                lon: lngNum,
            };

            return current_list
        });

        toast.success("Ubicación actualizada");
    }

    const returnValueCompany = (item) => {
        return objectCompany?.hasOwnProperty(item) ? objectCompany[item] : null;
    }

    const returnValueItem = (item) => {
        const position = currentBranch;
        return listBranchs[position].hasOwnProperty(item) ? listBranchs[position][item] : '';
    }

    function handleValueCompany(event, item) {
        const itsDifferent = item == 'country' ? 0 : (item == 'logoCompany' ? 2 : 1);
        if (itsDifferent == 1) event.preventDefault();

        const newVal = itsDifferent == 1 ? event.target.value : event;

        setObjectCompany((current_val) => ({ ...current_val, [item]: newVal }));
    }

    function handleValueBranchs(event, item) {
        sessionStorage.setItem('pichi', 'Camila deja de ser PUTAAAAA');

        const itsSelect = ['city', 'type', 'currency'].includes(item);

        if (!itsSelect) {
            event.preventDefault();
            event.stopPropagation();
        }

        const newVal = !itsSelect ? event.target.value : event;
        const position = currentBranch;

        setListBranchs((current_val) => {
            const current_branch = [...current_val];

            current_branch[position] = {
                ...current_branch[position],
                [item]: newVal
            };

            return current_branch;
        });
    }

    const regiones = paises_list.flatMap(pais => pais.region);

    const array_countrys = paises_list.map((obj) => ({ label: obj.name, value: obj.key_contry }));

    useEffect(() => {
        refCompanyObj.current = objectCompany;
    }, [objectCompany]);

    useEffect(() => {
        const current_val = refCompanyObj.current;
        refCompanyObj.current = { ...current_val, lis_branchs: listBranchs };
    }, [listBranchs]);

    useEffect(() => {
        return () => {
            if (!refCompanyObj?.current) return toast.info("no se cargo correctamente la data");
            const current_val_ref = Object(refCompanyObj.current);

            setDataCompanyProvider((current_val) => ({ ...current_val, ...current_val_ref }));
        };
    }, []);

    useEffect(() => {
        const { lis_branchs, ...restante } = dataCompanyProvider;
        const backup_company = typeof restante?.country == 'string' ? ({
            ...restante,
            country: array_countrys.find((obj) => obj.label == restante.country)
        }) : restante;

        setObjectCompany(backup_company);

        setListBranchs(
            dataCompanyProvider.lis_branchs.map((objs_branchs, index) => ({
                ...objs_branchs,
                type: objs_branchs.type == null ? type_branchs[0] : (
                    typeof objs_branchs.type == 'string' ? type_branchs.find((obj) => obj.value == objs_branchs.type) : objs_branchs.type
                ),
                currency: objs_branchs.currency == null ? type_currency[0] : (
                    typeof objs_branchs.currency == 'string' ? type_currency.find((obj) => obj.value == objs_branchs.currency) : objs_branchs.currency
                ),
            }))
        );
    }, []);

    return (
        <ul>
            <li className={'containir-login ' + (!stateModalMaps ? 'current-modal' : 'disable-modal')}>
                <h2>{its_company ? 'EDITAR ' : 'CREAR '}MI EMPRESA</h2>

                <form onSubmit={!its_company ? saveCompany : updateCompany}>
                    <div className='rows-3-same'>
                        <label >
                            <span><PersonCardIcon main_css={styleIcons} />ID Empresa</span>
                            <input
                                type='number'
                                name='nit_company'
                                placeholder='Identificacion de propiedad'
                                value={returnValueCompany('companyID')} onChange={(event) => handleValueCompany(event, 'companyID')}
                            />
                        </label>

                        <label >
                            <span><LaptopCreateIcon main_css={styleIcons} />Nombre del Negocio</span>
                            <input
                                type='text'
                                name='name_company'
                                placeholder='Nombre de empresa aquí...'
                                value={returnValueCompany('companyName')} onChange={(event) => handleValueCompany(event, 'companyName')}
                            />
                        </label>

                        <label >
                            <span><LongInfoIcon main_css={styleIcons} />Descripción:</span>
                            <input
                                type='text'
                                name='description_company'
                                placeholder='Descripción resumida aquí...'
                                value={returnValueCompany('companyDescription')} onChange={(event) => handleValueCompany(event, 'companyDescription')}
                            />
                        </label>
                    </div>

                    <div className='rows-3-same'>
                        <label>
                            <span><UbicationIcon main_css={styleIcons} />Pais</span>

                            <Select
                                options={array_countrys}
                                placeholder='Origen de negocio'
                                styles={customStyles()}
                                value={returnValueCompany('country')} onChange={(event) => handleValueCompany(event, 'country')}
                            />
                        </label>

                        <label >
                            <span><PaintIcon main_css={styleIcons} />Color Corporativo</span>
                            <span className="inputs-color">
                                <input
                                    type='color'
                                    name='theme_company'
                                    style={{ padding: '3px', borderRadius: '5px' }}
                                    value={returnValueCompany('colorCompany')} onChange={(event) => handleValueCompany(event, 'colorCompany')}
                                />

                                <input
                                    type='text'
                                    name='color_company'
                                    value={returnValueCompany('colorCompany')} onChange={(event) => handleValueCompany(event, 'colorCompany')}
                                />
                            </span>
                        </label>

                        <label>
                            <span><GeneralLogoIcon main_css={styleIcons} />Logo Publico</span>

                            <div
                                className={'add-product-image' + (dragState ? ' drag-active' : '')}
                                style={{ boxShadow: 'none' }}
                                drag-active
                                onDragOver={() => { if (!dragState) setDragState(true); }}
                                onDragLeave={() => setDragState(false)}
                            >
                                <input type='file' title='Agregar Producto' onChange={(event) => { event.stopPropagation(); addImage(event) }} accept='.jpg, .jpeg, .png' />

                                {
                                    dragState != true && (<div style={{ aspectRatio: '16/9', width: '200px', overflow: 'hidden', backgroundColor: 'rgba(0,0,0,0.3)' }}>
                                        <img src={returnValueCompany('logoCompany')?.temporal_img ?? returnFullURL(returnValueCompany('logoCompany'), 'cover')} style={{ height: '100%', width: '100%', objectFit: 'cover' }} />
                                    </div>)
                                }
                            </div>
                        </label>
                    </div>

                    <div className='container-branch-navigator'>
                        <hr style={{ width: '100%' }}></hr>

                        <div className='head-cbn'>
                            <ul>
                                {
                                    listBranchs.map((obj, index) => (
                                        <li
                                            className={currentBranch == index ? 'branch-selected' : ''}
                                            onClick={() => setCurrentBranch(index)}
                                            style={{ color: currentBranch == index ? '#000' : 'var(--theme-main)', width: currentBranch == index ? '180px' : '100px' }}
                                        >
                                            <input type="text" maxLength={30} value={obj?.fullName ?? `Local ${index + 1}`} onChange={(event) => handleBranchNames(event, index)} onBlur={(event) => handleBranchNames(event, index, true)} />
                                            {
                                                obj?.key_branch == null && (
                                                    <button className='default-buttons' onClick={(event) => removeBranch(event, index)}>
                                                        <CloseIcon style={{ fontSize: '15px', color: currentBranch == index ? '#000' : 'var(--theme-main)' }} />
                                                    </button>
                                                )
                                            }
                                        </li>
                                    ))
                                }
                            </ul>
                            {
                                listBranchs.length < 5 && (
                                    <button className='default-buttons' style={{ height: 'min-content !important' }} onClick={(event) => addBranch(event)}>
                                        <AddIcon style={{ color: 'var(--theme-main)', fontSize: '30px' }} />
                                    </button>
                                )
                            }
                        </div>
                        {/* city */}
                        {/* type */}
                        {/* currency */}
                        <div className='body-cbn'>
                            <div className='rows-3-same'>
                                <label >
                                    <span>Tipo de local</span>
                                    <Select
                                        options={type_branchs}
                                        value={returnValueItem('type')} onChange={(event) => handleValueBranchs(event, 'type')}
                                        placeholder='Tipo de local aquí...'
                                        styles={customStyles(false)}
                                        isSearchable={false}
                                    />
                                </label>

                                <label >
                                    <span>Tipo de Moneda</span>
                                    <Select
                                        options={type_currency}
                                        value={returnValueItem('currency')} onChange={(event) => handleValueBranchs(event, 'currency')}
                                        placeholder='Moneda preferida aquí...'
                                        styles={customStyles(false)}
                                        isSearchable={true}
                                    // isDisabled={its_company && listBranchs?.[currentBranch]?.key_branch}
                                    />
                                </label>

                                <label >
                                    <span title='Ej: Segundo Piso, corredor #4 etc...'>Detalle de Ubicación <InfoIcon style={{ fontSize: '15px' }} /></span>
                                    <input
                                        type='text'
                                        name='detail_branch'
                                        placeholder='Ingrese "virtual" si no tienes uno'
                                        value={returnValueItem('text_direction')} onChange={(event) => handleValueBranchs(event, 'text_direction')}
                                    />
                                </label>
                            </div>

                            <div className='rows-3-same'>
                                <label >
                                    <span title='Ignorar si no tienes una ubicación'>Ubicacion <InfoIcon style={{ fontSize: '15px' }} /></span>
                                    <input
                                        type='button'
                                        name='ubication_branch'
                                        value='Abrir Mapa'
                                        onClick={() => setStateModalMaps(true)}
                                    />
                                </label>

                                <label >
                                    <span>Numero de Contacto</span>
                                    <input
                                        type='number'
                                        name='phone_branch'
                                        placeholder='Numero de referencia aquí...'
                                        value={returnValueItem('phone')} onChange={(event) => handleValueBranchs(event, 'phone')}
                                        max={79999999}
                                        required
                                    />
                                </label>
                            </div>
                        </div>
                    </div>
                    {
                        // {
                        //     "key_branch": "46126c734ecc70022441d786f06536832aabd5c6dd62b",
                        //     "fullName": "virgen de cotoca 2do anillo",
                        //     "code": "S4A1",
                        //     "phone": 67855168,
                        //     "location_url": "https:\/\/www.google.com\/maps?q=-17.782388673218865,-63.159641106120304",
                        //     "lat": "-17.782388673218865",
                        //     "lon": "-63.159641106120304",
                        //     "day_ini": "Lunes",
                        //     "day_Fin": "S\u00e1bado",
                        //     "time_range": "7:30am - 18:30pm",
                        //     "particular_day": "Viernes",
                        //     "particular_time": "7:31am - 13:31pm"
                        // }
                    }
                    <input type="submit"
                        value={its_company ? (stateUpload ? "Actualizando..." : "Actualizar") : (stateUpload ? "Registrando..." : "Registrar")}
                        disabled={stateUpload}
                        style={{ color: key_branch ? 'var(--theme-company)' : 'var(--empresa-color)', opacity: '0.8' }}
                    />
                </form>
            </li>

            <li className={'containir-register ' + (stateModalMaps ? 'current-modal' : 'disable-modal')}>
                <h2>Ubica tu local</h2>

                <MapContainer center={[
                    listBranchs[currentBranch]?.lat ?? "-17.78356160586947",
                    listBranchs[currentBranch]?.lon ?? "-63.180527126488954"
                ]} zoom={16} style={{ height: '45vh', width: "100%" }}>
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    {/* <ChangeMapView coords={[
                            latitud,
                            longitud
                        ]} /> */}
                    <Marker position={[
                        listBranchs[currentBranch]?.lat ?? "-17.78356160586947",
                        listBranchs[currentBranch]?.lon ?? "-63.180527126488954"
                    ]} icon={customIcon}>
                        <Popup>Tu ubicación seleccionada</Popup>
                    </Marker>

                    {/* Manejador del click en el mapa */}
                    <MapClickHandler
                        onMapClick={(latlng) => updateCoordenadas(latlng.lat, latlng.lng)}
                    />
                </MapContainer>

                <input type="submit" onClick={() => setStateModalMaps(false)} value={'Cerrar Mapa'} style={{ color: key_branch ? 'var(--theme-company)' : 'var(--empresa-color)' }} />
            </li>
        </ul>
    )
}

export default MyCompanyUpdate